import { clsx } from 'clsx'
import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ProductDescriptionParsedField } from './ProductDescriptionParsedField'

export const ProductDescriptionTopDescriptions: FC<{
  className?: string
  product: PimProductV11
}> = ({ className, product }) => {
  return (
    <div className={clsx('flex flex-col', className)}>
      {product.description_short ? (
        <ProductDescriptionParsedField field={product.description_short} />
      ) : null}
      {product.description_extra ? (
        <ProductDescriptionParsedField field={product.description_extra} />
      ) : null}
      {product.lmiv_claim ? (
        <ProductDescriptionParsedField field={product.lmiv_claim} />
      ) : null}
    </div>
  )
}
